var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"id":_vm.id,"dochub-anchor":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }